module.exports = __webpack_public_path__ + "static/unnamed-a2dfe1ec98479f9869cd28df2c3899e8.png";